module.exports = __webpack_public_path__ + "fo.svg?32019da00e4ad54d1cda9ff412d32ca1";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/fo.svg
// module id = 1357
// module chunks = 0